export function getSurroundingPlaces(index: number, places: string[]) {
  const prevPlace = places[index - 1] || "";
  const nextPlace = places[index + 1] || "";
  return [prevPlace, nextPlace];
}
